// ===== High Tide — interactions =====
document.addEventListener('DOMContentLoaded', () => {
  /* Exact uploaded splash preloader timing */
  const splash = document.getElementById('htSplash');
  if (splash) {
    document.body.classList.add('ht-preloader-active');
    window.setTimeout(() => {
      splash.classList.add('ht-splash--wipe');
    }, 2350);

    window.setTimeout(() => {
      document.body.classList.add('ht-loaded');
      splash.classList.add('ht-splash--exit');
      document.body.classList.remove('ht-preloader-active');
    }, 3750);

    window.setTimeout(() => {
      splash.remove();
    }, 4300);
  }


  /* Mobile hamburger menu */
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const siteHeader = document.querySelector('.site-header');
  if (menuToggle && siteHeader) {
    menuToggle.addEventListener('click', () => {
      const isOpen = siteHeader.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('ht-menu-open', isOpen);
    });

    /* Close drawer when a mobile menu item is clicked. */
    siteHeader.querySelectorAll('.main-nav a, .btn-reach').forEach(link => {
      link.addEventListener('click', () => {
        siteHeader.classList.remove('is-open');
        document.body.classList.remove('ht-menu-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open menu');
      });
    });
  }

  /* Hero flavor/image cycler */
  const flavors = ['ISLAND PUNCH', 'CITRUS SURGE', 'LEMON LIME SPLASH', 'RIPTIDE COLA'];
  const flavorLinks = ['/products/island-punch', '/products/citrus-surge', '/products/lemon-lime-splash', '/products/riptide-cola', '/products/high-tide-variety-4-pack'];
  let idx = 0;
  const pill = document.getElementById('heroPill');
  const heroImg = document.querySelector('.hero-image img');
  const heroSlides = [
    'https://cdn.shopify.com/s/files/1/1006/6087/1461/files/PUT_YOUR_PHOTO_HERE_1.png?v=1782904543',
    'https://cdn.shopify.com/s/files/1/1006/6087/1461/files/PUT_YOUR_PHOTO_HERE_2.png?v=1782904543',
    'https://cdn.shopify.com/s/files/1/1006/6087/1461/files/Header_7.png?v=1782904543',
    'https://cdn.shopify.com/s/files/1/1006/6087/1461/files/Header_6.png?v=1782904543'
  ];
  /* Preload hero slides so the image changes instantly on arrow click. */
  heroSlides.filter(Boolean).forEach(src => {
    const img = new Image();
    img.src = src;
  });

  const setHeroSlide = () => {
    if (pill) { pill.textContent = flavors[idx]; if (flavorLinks[idx]) pill.setAttribute('href', flavorLinks[idx]); }
    if (heroImg && heroSlides[idx]) heroImg.src = heroSlides[idx];
  };

  const heroPrev = document.getElementById('heroPrev');
  const heroNext = document.getElementById('heroNext');
  if (heroPrev) heroPrev.addEventListener('click', () => {
    idx = (idx - 1 + flavors.length) % flavors.length;
    setHeroSlide();
  });
  if (heroNext) heroNext.addEventListener('click', () => {
    idx = (idx + 1) % flavors.length;
    setHeroSlide();
  });

  /* Product rail: slide one product at a time with no image reload delay. */
  const grid = document.getElementById('productGrid');
  const prodPrev = document.getElementById('prodPrev');
  const prodNext = document.getElementById('prodNext');
  let productRailBusy = false;
  let fallbackTimer = null;

  const getCardWidth = () => {
    const card = grid ? grid.querySelector('.product-card') : null;
    return card ? card.getBoundingClientRect().width : 0;
  };

  const finishSlide = (cleanup) => {
    clearTimeout(fallbackTimer);
    cleanup();
    grid.style.transition = 'none';
    grid.style.transform = 'translate3d(0,0,0)';
    productRailBusy = false;
  };

  const slideProducts = (direction) => {
    if (!grid || productRailBusy) return;
    const amount = getCardWidth();
    if (!amount) return;

    productRailBusy = true;
    grid.style.transition = 'none';
    grid.style.transform = 'translate3d(0,0,0)';

    if (direction === 'prev') {
      const last = grid.lastElementChild;
      if (!last) return;
      grid.insertBefore(last, grid.firstElementChild);
      grid.style.transform = `translate3d(-${amount}px,0,0)`;
      grid.offsetHeight;
      grid.style.transition = 'transform 220ms ease-out';
      grid.style.transform = 'translate3d(0,0,0)';

      const cleanup = () => finishSlide(() => {});
      grid.addEventListener('transitionend', cleanup, { once: true });
      fallbackTimer = setTimeout(cleanup, 320);
    } else {
      const first = grid.firstElementChild;
      if (!first) return;
      grid.style.transition = 'transform 220ms ease-out';
      grid.style.transform = `translate3d(-${amount}px,0,0)`;

      const cleanup = () => finishSlide(() => grid.appendChild(first));
      grid.addEventListener('transitionend', cleanup, { once: true });
      fallbackTimer = setTimeout(cleanup, 320);
    }
  };

  if (prodPrev) prodPrev.addEventListener('click', () => slideProducts('prev'));
  if (prodNext) prodNext.addEventListener('click', () => slideProducts('next'));

  /* Cart button feedback */
  document.querySelectorAll('.cart-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      btn.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }],
        { duration: 280, easing: 'ease-out' }
      );
    });
  });
});


/* High Tide — Add to cart for product hero/cart icons and flavor carousel cart buttons */
(function () {
  if (window.__HT_ADD_TO_CART_BOUND__) return;
  window.__HT_ADD_TO_CART_BOUND__ = true;

  var variantCache = {};

  function getButton(target) {
    return target && target.closest ? target.closest('.ht-add-to-cart') : null;
  }

  function setButtonState(button, state) {
    if (!button) return;
    button.classList.remove('is-loading', 'is-added', 'is-error');
    if (state) button.classList.add(state);
  }

  function cleanVariantId(value) {
    if (!value) return null;
    value = String(value).trim();
    if (!value || value === 'null' || value === 'undefined') return null;
    if (!/^\d+$/.test(value)) return null;
    return value;
  }

  function getCurrentProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }


  function getEmbeddedVariantId() {
    var el = document.querySelector('[data-current-variant-id]');
    return el ? cleanVariantId(el.getAttribute('data-current-variant-id')) : null;
  }

  async function resolveVariantId(button) {
    var directVariantId = cleanVariantId(button.getAttribute('data-variant-id'));
    if (directVariantId) return directVariantId;

    var handle = button.getAttribute('data-product-handle') || getCurrentProductHandle();
    var currentHandle = getCurrentProductHandle();
    if (handle && currentHandle && handle === currentHandle) {
      var embeddedVariantId = getEmbeddedVariantId();
      if (embeddedVariantId) return embeddedVariantId;
    }
    if (!handle) return null;

    if (variantCache[handle]) return variantCache[handle];

    var response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Could not load product: ' + handle);

    var product = await response.json();
    var variants = product && product.variants ? product.variants : [];
    var variant = variants.find(function (item) {
      return item && item.available !== false;
    }) || variants[0];

    if (!variant || !variant.id) throw new Error('No variant found for: ' + handle);

    variantCache[handle] = variant.id;
    return variant.id;
  }

  function getCartComponent() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getCartSections(cartComponent) {
    if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
      return cartComponent.getSectionsToRender().map(function (section) { return section.id; });
    }
    return ['cart-icon-bubble'];
  }

  function updateCartCount(cart) {
    if (!cart) return;
    document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]').forEach(function (countEl) {
      countEl.textContent = cart.item_count;
    });
    document.dispatchEvent(new CustomEvent('ht:cart:updated', { detail: cart }));
  }

  async function refreshCartCount() {
    try {
      var cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!cartResponse.ok) return;
      updateCartCount(await cartResponse.json());
    } catch (e) {}
  }


  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char];
    });
  }

  function ensureCartNotification() {
    var component = document.querySelector('cart-notification');
    if (component) return component;

    var wrapper = document.createElement('cart-notification');
    wrapper.innerHTML = '' +
      '<div class="cart-notification-wrapper">' +
        '<div id="cart-notification" class="cart-notification focus-inset color-background-1 gradient" aria-modal="true" aria-label="Item added to your cart" role="dialog" tabindex="-1">' +
          '<div class="cart-notification__header">' +
            '<h2 class="cart-notification__heading caption-large text-body">✓ Item added to your cart</h2>' +
            '<button type="button" class="cart-notification__close modal__close-button link link--text focus-inset" aria-label="Close"><span class="svg-wrapper">×</span></button>' +
          '</div>' +
          '<div id="cart-notification-product" class="cart-notification-product"></div>' +
          '<div class="cart-notification__links">' +
            '<a href="/cart" id="cart-notification-button" class="button button--secondary button--full-width">View cart</a>' +
            '<form action="/cart" method="post" id="cart-notification-form"><button class="button button--primary button--full-width" name="checkout">Check out</button></form>' +
            '<a href="/#all-flavors" class="link button-label">Continue shopping</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrapper);

    var closeButtons = wrapper.querySelectorAll('button[type="button"]');
    closeButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        var n = document.getElementById('cart-notification');
        if (n) n.classList.remove('active');
      });
    });

    return wrapper;
  }

  function forceOpenCartNotification(item) {
    var component = ensureCartNotification();
    var notification = document.getElementById('cart-notification');
    if (!notification) return;

    // Dawn's cart notification can remain hidden on custom layouts because the
    // default header is not rendered. Force the popup visible after Ajax add.
    notification.style.display = 'block';
    notification.style.visibility = 'visible';
    notification.style.opacity = '1';
    notification.style.zIndex = '999999';
    notification.style.pointerEvents = 'auto';

    var productBox = document.getElementById('cart-notification-product');
    if (productBox && item) {
      var image = item.image || item.featured_image || '';
      var title = item.product_title || item.title || 'Product';
      productBox.innerHTML = '<div class="cart-item ht-cart-notification-product-fallback">' +
        (image ? '<div class="cart-notification-product__image global-media-settings"><img src="' + escapeHtml(image) + '" alt="" width="70" height="70" loading="lazy"></div>' : '') +
        '<div class="cart-notification-product__title"><h3 class="cart-notification-product__name h4">' + escapeHtml(title) + '</h3></div>' +
      '</div>';
    }

    notification.classList.add('animate', 'active', 'ht-cart-popup-visible');
    document.body.classList.add('ht-cart-notification-open');
    if (typeof notification.focus === 'function') notification.focus();
  }

  function notificationIsOpen() {
    var notification = document.getElementById('cart-notification');
    return !!(notification && notification.classList.contains('active'));
  }


  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest && event.target.closest('cart-notification .cart-notification__close');
    if (!closeBtn) return;
    var notification = document.getElementById('cart-notification');
    if (notification) {
      notification.classList.remove('active', 'ht-cart-popup-visible');
      notification.style.pointerEvents = '';
    }
    document.body.classList.remove('ht-cart-notification-open');
  }, true);

  function getProductGallery() {
    var img = document.querySelector('.ht-product-page .hero-card > img');
    var fallback = img ? [{ src: img.currentSrc || img.src, alt: img.getAttribute('alt') || '' }] : [];
    var el = document.getElementById('ht-current-product-gallery');
    if (!el) return fallback;
    try {
      var gallery = JSON.parse(el.textContent || '[]') || [];
      gallery = gallery.filter(function (item) { return item && item.src; });
      return gallery.length ? gallery : fallback;
    } catch (e) {
      return fallback;
    }
  }

  var htHeroGalleryIndex = 0;
  var htHeroGalleryAnimating = false;

  function slideHeroProductImage(direction) {
    var card = document.querySelector('.ht-product-page .hero-card');
    var img = card && card.querySelector(':scope > img');
    if (!card || !img || htHeroGalleryAnimating) return;

    var gallery = getProductGallery();
    if (!gallery.length) return;

    var currentSrc = img.currentSrc || img.src || '';
    var matchedIndex = gallery.findIndex(function (item) {
      return currentSrc && item.src && (currentSrc === item.src || currentSrc.indexOf(item.src.split('?')[0]) !== -1 || item.src.indexOf(currentSrc.split('?')[0]) !== -1);
    });
    if (matchedIndex >= 0) htHeroGalleryIndex = matchedIndex;

    var nextIndex = gallery.length > 1
      ? (htHeroGalleryIndex + direction + gallery.length) % gallery.length
      : htHeroGalleryIndex;
    var nextItem = gallery[nextIndex] || gallery[0];
    var nextSrc = nextItem.src || img.src;
    var nextAlt = nextItem.alt || img.getAttribute('alt') || '';

    htHeroGalleryAnimating = true;

    // Preload the next product-gallery image before starting the movement.
    // This prevents the new image from appearing first and then animating again.
    var preload = new Image();
    preload.onload = function () {
      card.classList.add('ht-hero-gallery-animating');
      card.style.minHeight = img.offsetHeight + 'px';

      var incoming = img.cloneNode(false);
      incoming.src = nextSrc;
      incoming.alt = nextAlt;
      incoming.classList.add('ht-hero-gallery-img-next');
      incoming.setAttribute('aria-hidden', 'true');
      incoming.style.transition = 'none';
      incoming.style.transform = 'translate3d(' + (direction * 105) + '%,0,0)';
      incoming.style.opacity = '1';
      card.appendChild(incoming);

      img.style.transition = 'none';
      img.style.transform = 'translate3d(0,0,0)';
      img.style.opacity = '1';

      // Force one clean starting frame, then move both images exactly once.
      void incoming.offsetWidth;
      img.style.transition = 'transform 520ms cubic-bezier(.16,1,.3,1)';
      incoming.style.transition = 'transform 520ms cubic-bezier(.16,1,.3,1)';

      requestAnimationFrame(function () {
        img.style.transform = 'translate3d(' + (-direction * 105) + '%,0,0)';
        incoming.style.transform = 'translate3d(0,0,0)';
      });

      var done = false;
      function finish() {
        if (done) return;
        done = true;

        // Keep the centered incoming image visible while the original source is
        // updated underneath it, preventing a second slide, flash, or vibration.
        img.style.visibility = 'hidden';
        img.style.transition = 'none';
        img.style.transform = 'translate3d(0,0,0)';
        img.src = nextSrc;
        img.alt = nextAlt;

        requestAnimationFrame(function () {
          img.style.visibility = '';
          img.style.transition = '';
          img.style.transform = '';
          img.style.opacity = '';
          if (incoming && incoming.parentNode) incoming.parentNode.removeChild(incoming);
          card.classList.remove('ht-hero-gallery-animating');
          card.style.minHeight = '';
          htHeroGalleryIndex = nextIndex;
          htHeroGalleryAnimating = false;
        });
      }

      incoming.addEventListener('transitionend', finish, { once: true });
      window.setTimeout(finish, 700);
    };
    preload.onerror = function () {
      htHeroGalleryAnimating = false;
    };
    preload.src = nextSrc;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest && event.target.closest('.ht-product-page .hero-media .carousel-arrow');
    if (!arrow) return;
    event.preventDefault();
    event.stopPropagation();
    slideHeroProductImage(arrow.classList.contains('arrow-prev') ? -1 : 1);
  }, true);

  async function addToCart(button) {
    if (!button || button.classList.contains('is-loading')) return;

    setButtonState(button, 'is-loading');

    try {
      var variantId = await resolveVariantId(button);
      if (!variantId) throw new Error('Variant ID not found.');

      var cartComponent = getCartComponent();
      if (cartComponent && typeof cartComponent.setActiveElement === 'function') {
        cartComponent.setActiveElement(document.activeElement || button);
      }

      var payload = {
        id: Number(variantId),
        quantity: 1
      };

      if (cartComponent) {
        payload.sections = getCartSections(cartComponent);
        payload.sections_url = window.location.pathname;
      }

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });

      var data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Add to cart failed.');
      }

      setButtonState(button, 'is-added');
      button.setAttribute('aria-label', 'Added to cart');

      if (cartComponent && typeof cartComponent.renderContents === 'function' && data.sections) {
        try {
          cartComponent.renderContents(data);
        } catch (renderError) {
          console.warn('High Tide cart notification render fallback:', renderError && renderError.message);
          forceOpenCartNotification(data);
        }
      } else {
        forceOpenCartNotification(data);
        await refreshCartCount();
      }

      window.setTimeout(function () {
        if (!notificationIsOpen()) forceOpenCartNotification(data);
      }, 120);

      window.setTimeout(function () {
        button.classList.remove('is-added');
      }, 1800);
    } catch (error) {
      console.error(error);
      setButtonState(button, 'is-error');
      window.setTimeout(function () {
        button.classList.remove('is-error');
      }, 1800);
      console.warn('High Tide add-to-cart failed:', error && error.message);
      console.warn('Please check the product handle and Online Store availability.');
    } finally {
      button.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', function (event) {
    var button = getButton(event.target);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addToCart(button);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var button = getButton(event.target);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addToCart(button);
  }, true);
})();
